<script>
import { Bar } from 'vue-chartjs';
import format from 'date-fns/format';

export default {
  extends: Bar,
  computed: {
    chartData() {
      const { xAxis, yAxis } = this.$store.state.sales;

      const dateFormat = this.getDateFormat();

      const period = xAxis.map((value) => format(value, dateFormat));

      const chartData = {
        labels: period,
        datasets: [
          {
            label: 'Sales',
            data: yAxis,
            backgroundColor: 'green',
            borderWidth: 1,
          },
        ],
      };
      return chartData;
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0,
              },
            },
          ],
        },
      },
    };
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options);
    },
  },
  methods: {
    format,
    getDateFormat() {
      const filterBy = this.$store.state.queryInterval;
      switch (filterBy) {
        default:
        case 'DAY':
          return 'h a';
        case 'MONTH':
          return 'Do';
        case 'YEAR':
          return 'MMM';
      }
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
// https://stackoverflow.com/questions/63560472/update-vue-chartjs-yaxis-max-value-without-re-rendering-entire-vue-chart-js
// https://stackoverflow.com/questions/48312609/vuejs-chart-not-displaying-after-page-reload
// TODO: vue-chartjs only updates when the entire object in chartData is replaced
</script>
